"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AndroidLifecycleMethod;
(function (AndroidLifecycleMethod) {
    AndroidLifecycleMethod["OnPause"] = "onPause";
    AndroidLifecycleMethod["OnResume"] = "onResume";
})(AndroidLifecycleMethod = exports.AndroidLifecycleMethod || (exports.AndroidLifecycleMethod = {}));
